import React, { Component } from 'react';
import Parse from 'parse';

export default class ParseEditableInput extends Component {
  constructor(props) {
      super(props);
      this.state = ({
        value:this.props.parsevalue
      })
  }

  onChange = (e) => {
    var parent = this;
    var parseclass = this.props.parseclass;
    var parseobjectid = this.props.parseobjectid;
    var parsekey = this.props.parsekey;
    var value = e.target.value;
    parent.setState({
      value:value
    })
    var Query = Parse.Object.extend(parseclass);
    var query = new Parse.Query(Query);
    query.get(parseobjectid,{
      success: function (result) {
          result.set(parsekey,value)
          result.save(null, {
            success: function(result) {
            },
            error: function(result, error) {
              console.log(result)
            }
          });
      },
      error: function(error) {
          console.log("Error: " + error.code + " " + error.message);
      }
    })
  }

  render() {
    return (
      <div className="tiny-padding">
        <input
          type="text"
          value={this.state.value}
          onChange={this.onChange}
          placeholder="..." />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/parseEditableInput.js